<template>
  <div>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-form :model="addForm" ref="addFormRef" :inline="true" label-width="80px" class="font-bold">
        <el-form-item label="客服id" prop="kf_id" >
          <el-input size="small" v-model="addForm.kf_id" clearable placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="addForm.date"
            @change="getTransferList(true)"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="getTransferList(true)">搜索</el-button>
          <el-button size="small" @click="resetInput">重置</el-button>
        </el-form-item>

      </el-form>

      <el-table
        :data="transfer"
        border
        stripe
        show-summary
        :summary-method="getSummaries"
      >
        <el-table-column label="编号" type="index"></el-table-column>
        <el-table-column label="客服id" prop="KfID"></el-table-column>
        <el-table-column label="转化数量" prop="Num"></el-table-column>
        <el-table-column label="接待用户数" prop="ReceptionNum"></el-table-column>
        <el-table-column label="转化订单总金额" prop="TotalAmount"></el-table-column>
        <el-table-column label="退货数量" prop="ReturnNum"></el-table-column>
        <el-table-column label="退货占比" prop="ReturnPercentage"></el-table-column>
        <el-table-column label="客服名称" prop="KfName"></el-table-column>
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <!-- 修改按钮 -->
            <el-tooltip effect="dark" content="查看详情" placement="top" :enterable="false">
              <el-button type="primary" icon="el-icon-notebook-2" size="small" @click="showDetailData(scope.row.KfID, scope.row.KfName)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pagenum" :page-sizes="[10, 20, 50, 100]" :page-size="queryInfo.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>


    <!-- 单客户详情的对话框 -->
    <el-dialog title="单客服数据" width="70%" top="6vh" :visible.sync="detailData" @close="detailDialogClosed">
      <el-card>
        <el-date-picker
          v-model="queryDate"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          clearable
          @change="reqDetailData"
          >
        </el-date-picker>
        <el-button style="margin-left:15px;" type="primary" @click="reqDetailData">查询</el-button>
        <el-button style="margin-left:15px;" type="primary" @click="exportExcel">导出Excel表格</el-button>
      </el-card>
      <el-table
        :data="detailTransfer"
        border
        stripe
        class="detailTransfer"
        style="width: 100%;margin-top: 15px;"
        ref="detailTable"
        v-loading="detailLoading"
        :summary-method="detailTransferSummaries"
        show-summary
      >
        <el-table-column type="expand">
          <template v-slot="{ row }">
              <el-table
                :data="row.DetailList"
                stripe
                max-height="300"
                border
                :span-method="arraySpanMethod"
                style="width: 100%;margin-top: 0;">
                <el-table-column label="编号" type="index" />
                <el-table-column
                  prop="OrderId"
                  label="订单ID"
                  width="130">
                </el-table-column>
                <el-table-column
                  prop="MemberId"
                  label="用户ID"
                  width="80">
                </el-table-column>
                <el-table-column
                  prop="GoodsId"
                  label="商品ID"
                  width="80">
                </el-table-column>
                <el-table-column
                  prop="ShipStatus"
                  label="发货状态">
                </el-table-column>
                <el-table-column
                  prop="ReturnStatus"
                  label="退货状态">
                </el-table-column>
                <el-table-column
                  prop="Bn"
                  label="编码"
                  width="130">
                </el-table-column>
                 <el-table-column
                  prop="BuyCode"
                  label="导购ID"
                  width="80">
                </el-table-column>
                <el-table-column
                  prop="LoginAccount"
                  label="导购账户"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="Nums"
                  label="数量">
                </el-table-column>
                <el-table-column
                  prop="ActualPrice"
                  label="商品金额">
                </el-table-column>
              </el-table>
          </template>
        </el-table-column>
        <el-table-column label="编号" type="index"></el-table-column>
        <el-table-column label="客服id" prop="KfID"></el-table-column>
        <el-table-column label="转化数量" prop="Num"></el-table-column>
        <el-table-column label="接待用户数" prop="ReceptionNum"></el-table-column>
        <el-table-column label="转化订单总金额" prop="TotalAmount"></el-table-column>
        <el-table-column label="创建时间" prop="Created"></el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination @size-change="handleSizeChangeD" @current-change="handleCurrentChangeD" :current-page="queryInfoD.pagenum" :page-sizes="[10, 20, 50, 100]" :page-size="queryInfoD.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="totalD">
      </el-pagination>
    </el-dialog>

  </div>
</template>

<script>
  import { chat_get, chat_get_file } from '@/api'
  import { Loading } from 'element-ui';
  import { formatDate } from '@/utils'
  export default {
    name: 'transfer',
    data() {
      return {
        // 获取角色列表的参数对象
        queryInfo: {
          query: '',
          // 当前的页数
          pagenum: 1,
          // 当前每页显示多少条数据
          pagesize: 10
        },
        queryInfoD: {
          query: '',
          // 当前的页数
          pagenum: 1,
          // 当前每页显示多少条数据
          pagesize: 10
        },
        transfer: [],
        detailTransfer: [],
        total: 0,
        totalD: 0,
        addForm: {
          kf_id: '',
          date: null
        },
        detailData: false,
        Num: 0,
        TotalAmount: 0,
        ReceptionNum: 0,
        detailId: '',
        detailName: '',
        queryDate: [],
        // 退货状态
        ReturnStatus: {
          '0': '正常',
          '1': '已退货'
        },
        // 发货
        ShipStatus: {
          '0': '未发货',
          '1': '已发货',
          '2': '部分发货',
          '3': '部分退货',
          '4': '已退货',
          '5': '退货中',
          '6': '退货完成',
          '7': '退款中',
          '8': '退款完成'
        },
        detailLoading: false,
        detailSummarie: {
          Num: 0,
          ReceptionNum: 0
        }
      }
    },
    created() {
      this.getTransferList()
    },
    methods: {
      getTransferList(val = false) {
        let { kf_id, date } = this.addForm;
        let startAt,endAt;
        if (val) this.queryInfo.pagenum = 1;
        if (date && date.length > 0) {
          startAt = formatDate(date[0])
          endAt = formatDate(date[1])
        }
        chat_get(`/admin/v1/transformTotalList`, {
          size: this.queryInfo.pagesize,
          page: this.queryInfo.pagenum,
          kf_id,
          startAt,
          endAt
        }, res => {
          if (res.status == 200) {
            let {Transform, Num, Count, TotalAmount, ReceptionNum} = res.data.MessageContent;
            this.total = Count;
            this.Num = Num;
            this.TotalAmount = TotalAmount;
            this.ReceptionNum = ReceptionNum;
            this.transfer = Transform || [];
          }
        })
      },
      // 监听 pagesize 改变的事件
      handleSizeChange(newSize) {
        this.queryInfo.pagesize = newSize
        this.getTransferList()
      },
      // 监听 页码值 改变的事件
      handleCurrentChange(newPage) {
        this.queryInfo.pagenum = newPage
        this.getTransferList()
      },

      //详情： 监听 pagesize 改变的事件
      handleSizeChangeD(newSize) {
        this.queryInfoD.pagesize = newSize
        this.reqDetailData();
      },
      //详情： 监听 页码值 改变的事件
      handleCurrentChangeD(newPage) {
        this.queryInfoD.pagenum = newPage
        this.reqDetailData();
      },
      resetInput() {
        this.$refs.addFormRef.resetFields();
        this.getTransferList(true);
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        let countReturnNum = { ReturnNum: 0 }
        countReturnNum = data.reduce((a, b) => {
          return {
            ReturnNum: a.ReturnNum + b.ReturnNum
          }
        }, countReturnNum)

        columns.forEach((column, index) => {
          switch (index) {
            case 0:
              sums[index] = '合计';
              break;
            case 1:
              sums[index] = '';
              break;
            case 2:
              sums[index] = this.Num;
              break;
            case 3:
              sums[index] = this.ReceptionNum;
              break;
            case 4:
              sums[index] = this.TotalAmount.toFixed(2);
              break;
            case 5:
              sums[index] = countReturnNum.ReturnNum
              break;
          }
        });
        return sums;
      },
      detailTransferSummaries(param) {
        return ['', '', '合计', this.detailSummarie.Num, this.detailSummarie.ReceptionNum, ``, '', '']
      },
      reqDetailData() {
        this.detailLoading = true
        let query = ''
        if (this.queryDate && this.queryDate.length > 0) {
          query = '&startAt=' + formatDate(this.queryDate[0].getTime() - 28800000)
          query += '&endAt=' + formatDate(this.queryDate[1].getTime() - 28800000)
        }
        chat_get(`/admin/v1/transformList?size=${this.queryInfoD.pagesize}&page=${this.queryInfoD.pagenum}&kf_id=${this.detailId}${query}`, {}, res => {
          if (res.status == 200) {
            let {Transform, Num, Count, TotalAmount, ReceptionNum} = res.data.MessageContent;
            // 转化数量
            let sumNum = 0
            // 接待用户数
            let sumReception = 0

            Transform.forEach(item => {
              let orders = {}
              item.DetailList.forEach(it => {
                orders[it.OrderId] = orders[it.OrderId] || 0
                orders[it.OrderId]++
              })
              item.DetailList.forEach(it => {
                it.OrderNum = orders[it.OrderId]
                orders[it.OrderId] = 0
                it.ShipStatus = this.ShipStatus[it.ShipStatus]
                it.ReturnStatus = this.ReturnStatus[it.ReturnStatus]
              })
              sumNum += item.Num
              sumReception += item.ReceptionNum
            })
            this.detailSummarie = {
              Num: sumNum,
              ReceptionNum: sumReception
            }
            this.detailTransfer = Transform || [];
            this.totalD = Count;
            this.$nextTick(() => {
              let foot = document.querySelector('.detailTransfer .el-table__footer-wrapper')
              if (foot) {
                // let foot = this.$refs.detailTable.$children[this.$refs.detailTable.$children.length - 1].$el;
                let cell = foot.querySelectorAll('.is-leaf')[5].querySelector('.cell')
                if (cell) {
                  // 转化订单金额
                  let amount = 0
                  // 分享金额
                  let shareAmount = 0
                  // 退货金额
                  let returnsAmount = 0
                  this.detailTransfer.forEach(item => {
                    amount += item.TotalAmount * 1000
                    item.DetailList.forEach(item => {
                      if (item.LoginAccount) {
                        shareAmount += item.ActualPrice * 1000
                      }
                      if (item.ReturnStatus === '已退货') {
                        returnsAmount += item.ActualPrice * 1000
                      }
                    })
                  })
                  let html = `
                    <div class="tf-amount-box">
                      ${(amount / 1000).toFixed(2)} / ${(returnsAmount / 1000).toFixed(2)}
                      <div class="tf-amount-tip">
                        <div><span>总金额：</span>${(amount / 1000).toFixed(2)}</div>
                        <div><span>退货金额：</span>${(returnsAmount / 1000).toFixed(2)}</div>
                      </div>
                    </div>
                  `
                  cell.innerHTML = html
                }
              }
            })
            // this.Num = Num;
            // this.TotalAmount = TotalAmount;
            // this.ReceptionNum = ReceptionNum;
            // this.KfID = ''
          }
          this.detailLoading = false
        }, () => this.detailLoading = false)
      },
      arraySpanMethod({ row, column, rowIndex, columnIndex }) {
        if (column.property === 'OrderId') {
          return {
            rowspan: row.OrderNum,
            colspan: 1
          }
        }
        return {
          rowspan: 1,
          colspan: 1
        }
       
      },
      showDetailData(val, name) {
        this.queryDate = []
        this.detailData = true;
        this.detailId = val;
        this.detailName = name;
        this.queryInfoD.pagenum = 1
        this.reqDetailData();
      },
      detailDialogClosed() {
        this.detailId = ''
        this.detailName = ''
      },
      exportExcel() {
        let loadingInstance = Loading.service({ fullscreen: true })
        let query = ''
        if (this.queryDate && this.queryDate.length > 0) {
          query = '&startAt=' + formatDate(this.queryDate[0].getTime() - 28800000)
          query += '&endAt=' + formatDate(this.queryDate[1].getTime() - 28800000)
        }
        chat_get_file(`/admin/v1/transformExport?kf_id=${this.detailId}${query}`, {}, res => {
          var blob = res.data;
          var a = document.createElement('a');
          var url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = this.detailName + '_客服转化列表.xlsx';
          a.click();
          loadingInstance.close()
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .el-icon-circle-close {
    color: white !important;
  }
</style>
<style lang="less">
  .detailTransfer {
    .cell,.el-table__footer-wrapper {
      overflow: visible;
    }
    .tf-amount-box {
      z-index: 3;
      position: relative;
      cursor: pointer;
      display: inline-block;
    }
    .tf-amount-tip {
      display: none;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%) translateY(-100%);
      width: 200px;
      padding: 15px;
      background: #fff;
      box-shadow: 0 0 6px #aaa;
      border-radius: 4px;
      span {
        display: inline-block;
        width: 80px;
        text-align: right;
      }
    }
    .tf-amount-box:hover  .tf-amount-tip {
      display: block;
    }
  } 
</style>
